function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IcancelCircle = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.3993 4.66833C21.1596 -1.55611 10.9197 -1.55611 4.67988 4.66833C-1.55996 10.8928 -1.55996 21.1072 4.67988 27.3317C10.9197 33.5561 20.9996 33.5561 27.2393 27.3317C33.4792 21.1072 33.6392 10.8928 27.3993 4.66833ZM20.5196 22.7032L16.0396 18.2344L11.5597 22.7032L9.31978 20.4689L13.7997 16L9.31978 11.5312L11.5597 9.29676L16.0396 13.7656L20.5196 9.29676L22.7594 11.5312L18.2796 16L22.7594 20.4689L20.5196 22.7032Z",
    fill: "black"
  }));
});